/* Built In Imports */
import { useRef, useState } from 'react';

/* External Imports */
// import { Image } from '@chakra-ui/react';
import { Box, Flex, Image, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { nanoid } from 'nanoid';
import { IoChevronBackSharp, IoChevronForwardOutline } from 'react-icons/io5';
import Slider from 'react-slick';

/* Internal Imports */
/* Components */
import SectionTitle from '@eternal/Components/Headings/SectionTitle';
import StructuredTextParser from '@eternal/Components/Utility/StructuredTextParser';

/* Services */
/* Styles */
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

/* Services */

/**
 * Renders the Testimonials component.
 * @param {Object} testimonialsObj component.
 * @param {string} region - Region of page
 * @param {string} lang - Language of page
 * @returns {ReactElement} Testimonials component.
 */
const Testimonials = ({ testimonialsObj, region, lang }) => {
  // pbk
  const [activeIndex, setActiveIndex] = useState(0);
  let sliderRef = useRef(null);
  const next = () => {
    sliderRef?.slickNext();
  };
  const previous = () => {
    sliderRef?.slickPrev();
  };
  const settings = {
    dots: false,
    arrows: false,
    speed: 1000,
    className: 'eternal-slide',
    slidesToShow: 3.05,
    slidesToScroll: 1,
    // variableWidth: true,
    afterChange: index => setActiveIndex(index),
    infinite: true,
    responsive: [
      {
        breakpoint: 1920,
        settings: {
          slidesToShow: 3.05,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 2.1,
          slidesToScroll: 1,
          currentSlide: 1,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: false,
        },
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <Box w="100%" maxW="100%" overflow="hidden" p="20px 0 100px 0">
      {testimonialsObj?.title[0] && (
        <SectionTitle titleObj={testimonialsObj?.title[0]} />
      )}

      <Box
        maxW="95%"
        ml={{ base: 'auto', lg: '8%', xl: '5%', '2xl': '11%' }}
        mr={{ base: 'auto', '2xl': '0' }}
        w="100%"
      >
        <Flex
          pl={{ base: '17px', md: '1%', xl: '5%', '2xl': '0' }}
          w="100%"
          flexDir={{ base: 'column', md: 'row-reverse' }}
          alignItems="center"
          h="100%"
          justifyContent="space-between"
        >
          <Box
            w={{ base: '100%', md: '60%', '2xl': '70%' }}
            className="slider-container"
          >
            <Slider
              ref={slider => {
                sliderRef = slider;
              }}
              {...settings}
            >
              {testimonialsObj?.testimonials?.map((data, i) => {
                return (
                  <Flex
                    h="100%"
                    overflow="hidden"
                    p={{ base: '0 10px', md: '0 20px', '2xl': '0 20px 0 0' }}
                    key={nanoid()}
                    textAlign="center"
                    fontFamily="FedraSansStd-book"
                    w={`${100 / i}%`}
                    // maxW={{
                    //   base: Math.ceil(activeIndex) === i ? '100%' : 'auto',
                    //   md: Math.ceil(activeIndex) === i ? 'auto' : 215,
                    //   // md: Math.ceil(activeIndex) === i ? 300 : 215,
                    //   lg: Math.ceil(activeIndex) === i ? 'auto' : 285,

                    //   // lg: Math.ceil(activeIndex) === i ? 375 : 285,
                    //   '2xl': 'auto',
                    //   xl: Math.ceil(activeIndex) === i ? 370 : 284,
                    // }}
                  >
                    <Box
                      flex={1}
                      w="100%"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      {data?.photo?.url && (
                        <Box
                          w="100%"
                          // transition={
                          //   Math.ceil(activeIndex) === i && 'all 0.2s ease-out'
                          // }
                        >
                          <Image
                            bgColor="lightgray"
                            priority={false}
                            src={data?.photo?.url}
                            alt={data?.photo?.alt}
                            title={data?.photo?.title}
                            // transition={
                            //   Math.ceil(activeIndex) === i &&
                            //   'all 0.2s ease-out'
                            // }
                            height={{
                              base: Math.ceil(activeIndex) === i ? 300 : 226,
                              sm: Math.ceil(activeIndex) === i ? 400 : 300,
                              lg: Math.ceil(activeIndex) === i ? 540 : 401,
                              xl: Math.ceil(activeIndex) === i ? 560 : 420,
                            }}
                            w="100%"
                            my="auto"
                            verticalAlign={{ base: 'baseline', md: 'middle' }}
                            objectFit="cover"
                            objectPosition="top"
                            //pb="1vw"
                          />
                          <Text
                            textAlign="left"
                            color="#000"
                            fontSize={{ base: '14px', md: '16px', lg: '22px' }}
                            fontWeight="500"
                            fontFamily="FedraSansStd-A-medium"
                            mt="10px"
                          >
                            {activeIndex !== i && data.userName}
                          </Text>
                        </Box>
                      )}
                    </Box>
                    {/* <Flex>
                  {activeIndex === i ? (
                    <Box flex={1}>
                      <StructuredTextParser
                        tAlign="center"
                        font="16px"
                        str={render(data?.testimonialText)}
                        region={region}
                        lang={lang}
                      />
                      {data?.userName && (
                        <Box
                          marginTop="15px"
                          textAlign="center"
                          fontWeight={'normal'}
                        >
                          - {data?.userName}
                        </Box>
                      )}
                    </Box>
                  ) : (
                    ''
                  )}
              
                </Flex> */}
                  </Flex>
                );
              })}
            </Slider>
          </Box>
          <Box
            w={{ base: '100%', md: '40%', '2xl': '30%' }}
            pr={{ base: '16px', md: '5%', '2xl': '1%' }}
            maxW="500px"
            height="100%"
          >
            <Flex
              flexDir="column"
              justifyContent="space-between"
              minW={{ base: '100%', md: 270, lg: 356, xl: 1 }}
              height="100%"
            >
              <StructuredTextParser
                tAlign="center"
                maxW={404}
                fontFamily="FedraSansStd-book"
                mx="0"
                fontSize={{ base: '16px', md: '18px', lg: '20px' }}
                str={render(
                  testimonialsObj?.testimonials[activeIndex]?.testimonialText
                )}
                region={region}
                lang={lang}
                mb="10%"
              />
              {testimonialsObj?.testimonials[activeIndex]?.userName && (
                <Box marginTop="2.5rem" textAlign="left" fontWeight={'normal'}>
                  <Text
                    textAlign="left"
                    color="#000"
                    fontSize={{ base: '14px', md: '16px', lg: '22px' }}
                    fontWeight="500"
                    fontFamily="FedraSansStd-A-medium"
                  >
                    {testimonialsObj?.testimonials[activeIndex]?.userName}
                  </Text>
                  <StructuredTextParser
                    tAlign="center"
                    fontSize={{ base: '14px', md: '16px', lg: '16px' }}
                    str={render(
                      testimonialsObj?.testimonials[activeIndex]
                        ?.userDescription
                    )}
                    region={region}
                    fontFamily="FedraSansStd-book"
                    lang={lang}
                  />
                </Box>
              )}
              <Flex gap="20px" display={{ base: 'none', md: 'flex' }} mt="30px">
                <Flex
                  onClick={previous}
                  cursor="pointer"
                  rounded="full"
                  border="1px solid #C9BAAB"
                  alignItems="center"
                  justifyContent="center"
                  height={50}
                  w={50}
                  _hover={{ background: '#C9BAAB' }}
                >
                  <IoChevronBackSharp size={25} />
                </Flex>
                <Flex
                  onClick={next}
                  cursor="pointer"
                  rounded="full"
                  border="1px solid #C9BAAB"
                  alignItems="center"
                  justifyContent="center"
                  _hover={{ background: '#C9BAAB' }}
                  height={50}
                  w={50}
                >
                  <IoChevronForwardOutline size={25} />
                </Flex>
              </Flex>
            </Flex>
          </Box>
        </Flex>
      </Box>
      <style global jsx>
        {`
          .eternal-slide .slick-track,
          .eternal-slide .slick-list {
            display: flex;
            flex-direction: row;
            align-items: center;
          }
        `}
      </style>
    </Box>
  );
};

export default Testimonials;
